export default __webpack_public_path__ + "static/media/linkedin-logo.72f93c1a.svg";